<div class="table-container table-reponsive">
  <div class="table-responsive">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" id="htmlData" matSort>
      <!-- (matSortChange)="onSortChange($event)"-->
      @for (column of gridInfoData; track gridInfoData) {
      @if (column.fieldname== 'select') {
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row, index)">
          </mat-checkbox>

          @if (row.notescount > 0) {
          <span>{{ row.notesCount }}</span>
          <svg class="pc-icon" style = "cursor: pointer;" (click)="showNotes(row.id)">
            <use xlink:href="assets/fonts/custom-icon.svg#custom-note-1"></use>
          </svg>
          }

          @if (row.attachcount > 0) {
          <span>{{ row.attachCount }}</span>
          <svg class="pc-icon" style="cursor: pointer;" (click)="attachedFiles(row.id)">
            <use xlink:href="assets/fonts/custom-icon.svg#attach"></use>
          </svg>
          }
        </td>
      </ng-container>
      } @else if (column.fieldname== 'action') {
      <!-- action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="text-center"> {{ 'actions' | translate }} </th>
        <td mat-cell *matCellDef="let element; let i = index" class="text-center">
          <div class="text-end text-nowrap">
            <ul class="list-inline p-l-0" style="margin-top:0.5rem; margin-bottom: 0.5rem;">
              <!--     <li class="list-inline-item m-r-10" matTooltip="View" (click)="showDetails(element.id)">
                <a href="javascript:" class="avatar avatar-xs text-muted">
                  <i class="ti ti-eye f-18"></i>
                </a>
              </li> -->
              @if (canEdit && permissions?.edit && enabledByFieldValue(element) ) {
              <li class="list-inline-item m-r-10" (click)="detailsEdit(element,element.id)">
                <a href="javascript:" class="avatar avatar-xs text-muted" pTooltip="{{ 'edit' | translate }}"
                  tooltipPosition="top">
                  <i class="ti ti-edit-circle f-18"></i>
                </a>
              </li>
              }@else {
                  <li class="list-inline-item m-r-10" (click)="detailsEdit(element,element.id)">
                <a href="javascript:" class="avatar avatar-xs text-muted" pTooltip="{{ 'view' | translate }}"
                  tooltipPosition="top">
                  <!-- <i class="ti ti-edit-circle f-18"></i> -->
                  <i class="ti ti-eye f-18"></i>
                </a>
              </li>
              }
              @if (canDelete && permissions?.delete && enabledByFieldValue(element) && deleteEnabledByFieldValue(element)) {
              <li class="list-inline-item m-r-10" (click)="deleteRow(element,element.id, i)">
                <a href="javascript:" class="avatar avatar-xs text-warn-500" pTooltip="{{ 'delete' | translate }}"
                  tooltipPosition="top">
                  <i class="ti ti-trash f-18"></i>
                </a>
              </li>
              }
              <li class="list-inline-item m-r-10">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"
                  pTooltip="{{ 'more' | translate }}" tooltipPosition="top" disableRipple class="action-menu-btn">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu" class="main-menu">
                  @if (canEdit && permissions?.edit) {
                  <!-- <button mat-menu-item [matMenuTriggerFor]="menuAttach"> -->
                    <!-- <mat-icon>notifications_off</mat-icon> -->
                    <!-- <span>{{ 'attachments' | translate }}</span> -->
                    <!-- <mat-menu #menuAttach="matMenu"> -->
                      <button mat-menu-item (click)="attachFile(element.id)">
                        <mat-icon class="small-icon">attach_file</mat-icon>
                        <span class="menu-text">{{ 'attachments' | translate }}</span>
                      </button>
                      <!--     <button mat-menu-item (click)="attachedFiles(element.id)">
                        <mat-icon>notifications_off</mat-icon>
                        <span>الملفات المرفقه المرتبطة بالشاشة </span>
                      </button> -->
                    <!-- </mat-menu> -->
                  <!-- </button> -->
                  <button mat-menu-item (click)="showNotes(element.id)">
                    <mat-icon class="small-icon">note_alt</mat-icon>
                    <span class="menu-text">{{ 'notes' | translate }}</span>
                  </button>
                  }

                  @if (permissions?.print) {
                  <button mat-menu-item [matMenuTriggerFor]="menuExport">
                    <mat-icon class="small-icon">file_download</mat-icon>
                    <span class="menu-text">{{ 'exportFiles' | translate }}</span>
                  </button>
                  <mat-menu #menuExport="matMenu">
                    <button mat-menu-item (click)="exportCSV(element.id)">
                      <span>{{ 'CSV' | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="exportExcel(element.id)">
                      <span> {{ 'excel' | translate }} </span>
                    </button>
                    <button mat-menu-item (click)="exportPdf(element.id)">
                      <span> {{ 'pdf' | translate }} </span>
                    </button>
                  </mat-menu>
                  }

                  <button mat-menu-item (click)="showInfo(element.id)">
                    <mat-icon class="small-icon">info</mat-icon>
                    <span class="menu-text">{{ 'info' | translate }}</span>
                  </button>
                  @if (element['TAB_SMS']) {
                  <button mat-menu-item (click)="sendSMS(element.id)">
                    <!-- <mat-icon>notifications_off</mat-icon> -->
                    <span>{{ 'SMS' | translate }}</span>
                  </button>
                  }
                  @if (element['TAB_Whatsup']) {
                  <button mat-menu-item (click)="sendWhatup(element.id)">
                    <!-- <mat-icon>notifications_off</mat-icon> -->
                    <span>{{ 'whatsup' | translate }}</span>
                  </button>
                  }
                  @if (element['TAB_Email']) {
                  <button mat-menu-item (click)="sendEmail(element.id)">
                    <!-- <mat-icon>notifications_off</mat-icon> -->
                    <span>{{ 'email' | translate }}</span>
                  </button>
                  }

                  @for (item of gridMenu; track item) {
                  <button mat-menu-item (click)="execStoredProcedure(element.id, item.functionName)">
                    <mat-icon>{{ item.icon }}</mat-icon>
                    <span>{{ item.commandName | translate }}</span>
                  </button>
                  }
                </mat-menu>
              </li>
            </ul>
          </div>
        </td>
      </ng-container>
      }
      @else if (column.fieldtype == 'icon') {
      <!-- Icon Column (Tabler icons) -->
      <ng-container [matColumnDef]="column.fieldname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ currentLang ==='ar' ? column.displayaraname : column.displaylatname }}
        </th>
        <td mat-cell *matCellDef="let row" class="text-center">
          @if (row._entitydto[column.fieldname]) {
            <i class="ti ti-{{ row._entitydto[column.fieldname] }} f-24"
               [style.color]="row._entitydto['activitycolorhex'] || '#3498db'"></i>
          } @else {
            <span>----</span>
          }
        </td>
      </ng-container>
      }
      @else if (column.fieldtype == 'category-badge') {
      <!-- Category Badge Column (icon + colored label) -->
      <ng-container [matColumnDef]="column.fieldname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ currentLang ==='ar' ? column.displayaraname : column.displaylatname }}
        </th>
        <td mat-cell *matCellDef="let row" class="text-center">
          @if (row._entitydto[column.fieldname]) {
            @switch (row._entitydto['category']) {
              @case (1) {
                <span class="category-badge category-call">
                  <i class="ti ti-phone f-16"></i>
                  <span>{{ row._entitydto[column.fieldname] }}</span>
                </span>
              }
              @case (2) {
                <span class="category-badge category-request">
                  <i class="ti ti-mail f-16"></i>
                  <span>{{ row._entitydto[column.fieldname] }}</span>
                </span>
              }
              @case (3) {
                <span class="category-badge category-visit">
                  <i class="ti ti-map-pin f-16"></i>
                  <span>{{ row._entitydto[column.fieldname] }}</span>
                </span>
              }
              @default {
                <span>{{ row._entitydto[column.fieldname] }}</span>
              }
            }
          } @else {
            <span>----</span>
          }
        </td>
      </ng-container>
      }
      @else if (column.fieldname == 'profilepic' || column.fieldtype == 'Image') {
      <!-- Image Column -->
      <ng-container [matColumnDef]="column.fieldname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ currentLang ==='ar' ? column.displayaraname : column.displaylatname }}
        </th>

        <td mat-cell *matCellDef="let row" class="text-center">
          <div class="flex">
            <div class="flex-shrink-0">
              @if (row._entitydto[column.fieldname]) {
              <img src="{{ row._entitydto[column.fieldname] }}" alt="user-image"
                class="wid-50 border-50 image" />
              } @else {
              <img src="assets/images/user-placeholder.png" alt="user-image" class="wid-50 border-50 image" />
              }
            </div>
          </div>
        </td>
      </ng-container>
      }
      @else if (column.fieldname == 'phonenumber' || column.fieldname.toLowerCase().includes('mobile')) {
      <ng-container [matColumnDef]="column.fieldname">

        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ currentLang ==='ar' ? column.displayaraname : column.displaylatname }}
        </th>
        <td mat-cell *matCellDef="let row" style="direction: ltr;" class="text-center">
          {{ row._entitydto[column.fieldname] ? (row._entitydto[column.fieldname] | phoneFormat) : '----' }}
        </td>
      </ng-container>
      }
      @else if(column.fieldtype === 'boolean' || column.fieldtype === 'bit') {
      <!-- boolean fields -->
      <ng-container [matColumnDef]="column.fieldname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ currentLang ==='ar' ? column.displayaraname : column.displaylatname}}
        </th>
        <td mat-cell *matCellDef="let row; let i = index" class="text-center">
          <mat-checkbox [checked]="row._entitydto[column.fieldname]" [disableRipple]="true"
            (click)="$event.preventDefault()">
          </mat-checkbox>
        </td>
      </ng-container>
      }
      @else if (column.fieldname.toLowerCase().includes('colorhex')) {
      <!-- Color hex fields - display as color swatch -->
      <ng-container [matColumnDef]="column.fieldname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ currentLang ==='ar' ? column.displayaraname : column.displaylatname }}
        </th>
        <td mat-cell *matCellDef="let row" class="text-center">
          @if (row._entitydto[column.fieldname]) {
            <span class="color-swatch"
                  [style.background-color]="row._entitydto[column.fieldname]">
            </span>
          } @else {
            <span>----</span>
          }
        </td>
      </ng-container>
      }
      @else {
      <!-- normal fields -->
      <ng-container [matColumnDef]="column.fieldname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ currentLang ==='ar' ? column.displayaraname : column.displaylatname }}
        </th>
        <td mat-cell *matCellDef="let row" class="text-center">
          {{ row._entitydto[column.fieldname] != null && row._entitydto[column.fieldname] !== '' ? row._entitydto[column.fieldname] : '----' }}

        </td>
      </ng-container>
      }
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{ 'NoDatabyFilter' | translate }}</td>
      </tr>
    </table>
    <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator> -->
    <!-- <mat-paginator #paginator [length]="totalcount" [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator> -->
    <app-custom-pagination [totalRecords]="totalcount" (pageChange)="onPageChange($event)"/>
  </div>
</div>
